import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { Y42EntityStore } from '@y42/state';
import { InvitedUserStoreModel, OrgUserState } from '../models/org-user.model';

const initialState: OrgUserState = {
  invited: null,
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'org-user', idKey: 'id' })
export class OrgUserStore extends Y42EntityStore<OrgUserState> {
  constructor() {
    super(initialState);
  }

  setInvitedUsers(invitedUsers: InvitedUserStoreModel[]): void {
    this.update({
      invited: [...invitedUsers],
    });
  }

  addInvitedUser(invitedUser: InvitedUserStoreModel): void {
    this.update((state) => ({
      invited: [...(state.invited || []), invitedUser],
    }));
  }

  removeInvitedUser(invitedUserId: InvitedUserStoreModel['id']): void {
    this.update((state) => {
      const invited = (state.invited || []).slice();
      const index = invited.findIndex((invitedUser) => invitedUser.id === invitedUserId);
      if (index !== -1) {
        invited.splice(index, 1);
      }

      return {
        invited,
      };
    });
  }
}
